// ar/channel.js
export const channel = {
  header: {
    title: "قنوات الحجز",
    subtitle: "زامِن أو أدِر Booking.com وExpedia وAirbnb والمزيد.",
  },

  establishedConnections: "الاتصالات القائمة",

  common: {
    loading: "جارٍ التحميل...",
    configure: "إعداد",
    close: "إغلاق",
    comingSoon: "قريبًا",
  },

  alerts: {
    bullets: {
      choosePlan: "اختر خطة وفعّل مدير القنوات الخاص بك.",
      completeProperty: "أكمل إعداد وحدة إقامتك في لوحة التحكم.",
    },
    title: "إجراء مطلوب",
    planRequired:
      "يجب أن تكون لديك خطة نشطة لربط وحدة إقامتك بإحدى قنوات OTA.",
    missingPropertyChannel:
      "للاتصال بإحدى قنوات OTA، تحتاج أولاً إلى إكمال إعداد وحدة إقامتك في مدير القنوات.",
  },

  modal: {
    channelHeader: "اتصال القناة مع {channel}",
  },

  web: {
    cardTitle: "الحجوزات المباشرة عبر الويب",
    // NEW: description for the OTA-style card
    cardDescription:
      "استقبل حجوزات مباشرة من موقعك الإلكتروني دون عمولات OTA.",
    // NEW: button texts for card and table
    manageCta: "إدارة",
    configureCta: "إعداد",
    // NEW: label for the ID column of the direct bookings row
    directLinkLabel: "رابط الحجز المباشر",

    linkShareMessage: "مرحبًا 👋 يمكنك الحجز باستخدام هذا الرابط:\n\n{link}",
    modalTitle: "الحجوزات المباشرة عبر الويب",
    description:
      "فعّل أو عطّل الخيارات المتاحة للحجز المباشر على موقعك الإلكتروني. سيتمكّن الضيوف من الحجز مباشرةً دون وسطاء.",
    toggleAllDesktop: "تفعيل/تعطيل جميع الحجوزات عبر الويب",
    toggleAllMobile: "تفعيل/تعطيل",
    table: {
      name: "الاسم",
      available: "متاح للحجز عبر الويب",
    },
    capacity: "السعة",
    people: "أشخاص",
    empty: "لم يتم العثور على عناصر",

    // Link section
    linkTitle: "رابط الحجز المباشر الخاص بك",
    linkHelp: "شارك هذا الرابط ليتمكّن ضيوفك من الحجز مباشرةً",
    linkCopyTooltip: "نسخ الرابط",
    linkShareWhatsappTooltip: "المشاركة عبر WhatsApp",
  },

  plan: {
    title: "فعّل خطتك للاتصال",
    subtitle:
      "اختر الخطة التي تناسب احتياجاتك وفعّل الاتصال مع Booking وAirbnb وExpedia والمزيد.",
    hint: "بمجرد اشتراكك، عُد إلى هنا؛ وسنفتح لك جميع القنوات التي يمكنك الاتصال بها.",
    cta: "ترقية الخطة",
  },

  toasts: {
    paymentTypeUpdated: "تم تحديث طريقة الدفع بنجاح",
    linkCopiedTitle: "تم النسخ!",
    linkCopiedBody: "تم نسخ الرابط بنجاح",
    linkCopyErrorTitle: "خطأ",
    linkCopyErrorBody: "حدث خطأ أثناء نسخ الرابط",
    save: "خطأ في حفظ الإعدادات",
    updateWebReservation: "خطأ في تحديث الحجز عبر الويب",
    saved: "تم حفظ الإعدادات بنجاح",
    updateWebReservationsGlobal:
      "تم تحديث الحالة العامة للحجوزات المباشرة بنجاح",
  },

  errors: {
    loadData: "خطأ في تحميل البيانات. يرجى المحاولة مرة أخرى.",
    generateToken: "خطأ في إنشاء الرمز",
    connectChannel: "خطأ في الاتصال بالقناة. يرجى المحاولة مرة أخرى.",
    updatePaymentType: "خطأ في تحديث طريقة الدفع",
    save: "خطأ في حفظ الإعدادات",
    updateWebReservation: "خطأ في تحديث الحجز عبر الويب",
  },

  tabs: {
    reservations: "حالة الحجز",
    payments: "الأسعار والمدفوعات",
    share: "مشاركة",
  },

  payments: {
    title: "كيف تريد استلام مدفوعات الحجوزات المباشرة؟",
    onArrival: {
      label: "الدفع في مكان الإقامة",
      desc: "سيدفع الضيوف مباشرةً عند الوصول",
    },
    online: {
      label: "الدفع المسبق عبر الإنترنت",
      desc: "سيدفع الضيوف عند إجراء الحجز",
    },
  },

  discounts: {
    sectionTitle: "إعداد خصم للحجوزات المباشرة",
    toggle: "تطبيق خصم على الحجوزات المباشرة",
    typeTitle: "نوع الخصم:",
    percentage: {
      label: "خصم بنسبة مئوية",
      desc: "طبّق خصمًا بنسبة مئوية",
    },
    fixed: {
      label: "خصم بسعر ثابت",
      desc: "طبّق خصمًا بمبلغ ثابت",
    },
    valueTitle: "قيمة الخصم:",
    placeholderPercentage: "مثال: 10",
    placeholderFixed: "مثال: 50.00",
    helpPercentage:
      "أدخل قيمة بين 1 و100 لنسبة الخصم المئوية",
    helpFixed: "أدخل المبلغ الثابت باليورو المراد خصمه من الإجمالي",
    previewTitle: "معاينة:",
    previewPercentage: "سيتم تطبيق خصم بنسبة {value}% على الحجوزات المباشرة",
    previewFixed: "سيتم تطبيق خصم بقيمة {value}€ على الحجوزات المباشرة",
  },

  buttons: {
    saveChanges: "حفظ التغييرات",
  },
};
